import React from "react";
import { ReactComponent as TimelineSvg } from "../../assets/images/linearTimeline.svg";
import BuyNowCart from "./BuyNowCart";
import PaymentToggleCards from "./PaymentToggleCard";
import ToggleCards from "./ToggleCard";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

const BuyNow = () => {
  return (
    <div>
      <p className="text-xl text-dark font-medium mt-4 mx-8">
        you're almost ready to there...!
      </p>

      {/* Timeline */}
      <div className="md:mx-12 grid grid-cols-12">
        <div className="col-span-1">
          <div className="ml-2 -mt-20 md:ml-12 md:mt-10 md:m-10">
            <TimelineSvg className="px-1 md:px-0"/>
          </div>
        </div>
        <div className="col-span-11  my-6 md:my-10">
          {/* Adress Part */}
          <div className="mt-2 ml-8 md:ml-0">
            <p className="text-base text-grey">delivery address</p>
            <ToggleCards />
          </div>
          {/* Order Summary || Cart*/}
          <div className="mt-[40px] md:mt-[10px] ml-8 md:ml-0">
            <p className="text-base text-grey "> order summary</p>
            <div className="w-full md:w-2/5 mt-4 md:mt-10 -ml-4 md:ml-0">
              <BuyNowCart />
            </div>
          </div>
          {/* Payment Details */}

          <div className="ml-8 md:ml-0 mt-[50px] md:mt-[70px]">
            <p className="text-base text-grey "> payment details</p>
            <div className="md:mt-10">
              <div className="my-2 md:my-6">
                <FormControl component="fieldset">
                  <RadioGroup
                    row
                    aria-label="gender"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      value="credi/debit card"
                      sx={{ marginRight: {sx: "10px",md: "40px"} }}
                      control={
                        <Radio
                          sx={{
                            color: "#C6CDE0",
                            "&.Mui-checked": {
                              color: "#32BF77",
                            },
                          }}
                        />
                      }
                      label="credi/debit card"
                    />
                    <FormControlLabel
                      value="cash"
                     sx={{ marginRight: {sx: "10px",md: "40px"} }}
                      control={
                        <Radio
                          sx={{
                            color: "#C6CDE0",
                            "&.Mui-checked": {
                              color: "#32BF77",
                            },
                          }}
                        />
                      }
                      label="cash on delivery"
                    />
                    <FormControlLabel
                      value="upi"
                     sx={{ marginRight: {sx: "10px",md: "40px"} }}
                      control={
                        <Radio
                          sx={{
                            color: "#C6CDE0",
                            "&.Mui-checked": {
                              color: "#32BF77",
                            },
                          }}
                        />
                      }
                      label="upi"
                    />
                    <FormControlLabel
                      value="emi"
                      control={
                        <Radio
                          sx={{
                            color: "#C6CDE0",
                            "&.Mui-checked": {
                              color: "#32BF77",
                            },
                          }}
                        />
                      }
                      label="emi"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <PaymentToggleCards />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyNow;
